import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/modules/authentication/services/login.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    public urlHome       : string = '/home';
    public urlProfile    : string = '/tutor';
    public urlStudents   : string = '/participantes';
    public urlEnrollments: string = '/inscripciones';

    public urlLogo: string = 'static/images/logos/logo-comillas.png';

    constructor(private loginService: LoginService) { }

    ngOnInit(): void { }

    public logout() {

        this.loginService.logout();

    }

}
